module.exports = __webpack_public_path__ + "static/img/ps_reg.742dfded.png";